module.exports = __webpack_public_path__ + "static/img/03.bd11366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/app/03.png
// module id = ZgQD
// module chunks = 0